import { getBffIndUrl, SESSION_KEYS } from "./shared/config";
import { createServiceClient } from "./shared/clientFactory";

const indClient = createServiceClient({
  baseURL: getBffIndUrl(),
  tipo: "2",
  initTokenStorageKey: SESSION_KEYS.IND_INIT_TOKEN,
  awsAuthStorageKey: SESSION_KEYS.IND_AWS_AUTH_TOKEN,
});

export const {
  instance,
  getRequest,
  postRequest,
  putRequest,
  deleteRequest,
  downloadRequest,
  encodeBasicCredential,
} = indClient;